import React, { useState } from 'react';
import { FilterToggle } from '.';
import { PillFilterType } from '../../types/prismic';

import styles from './filter.module.sass';

interface Props {
  label?: string;
  data?: PillFilterType[];
  minimized?: boolean;
  selectedFilters?: string[];
  onUpdate: (string) => void;
}

const PillFilter = ({
  label,
  data,
  minimized,
  selectedFilters,
  onUpdate,
}: Props) => {
  const [hoverIndex, setHoverIndex] = useState(null);
  const [open, setOpen] = useState(true);

  return (
    <div className={`${styles.filters} ${label ? styles.full : ''}`}>
      <div className={`${styles.wrapper} ${styles.open}`}>
        {label && (
          <FilterToggle
            label={label}
            onSelected={() => setOpen(!open)}
            selected={open}
          />
        )}
        <nav className={`${styles.container} ${minimized ? styles.minimized : ''}`}>
          {open &&
            data &&
            data.length &&
            data.map((category, index) => (
              <button
                key={`cat-${index}`}
                onClick={() => onUpdate(category.value)}
                onMouseOut={() => setHoverIndex(null)}
                onMouseUp={() => setHoverIndex(null)}
                onMouseOver={() => setHoverIndex(index)}
                className={`${styles.button} ${
                  selectedFilters && selectedFilters.includes(category.value)
                    ? styles.selected
                    : ''
                } ${
                  hoverIndex !== null
                    ? hoverIndex === index
                      ? styles.highlighted
                      : styles.blackout
                    : ''
                }`}
              >
                {category.label}
              </button>
            ))}
        </nav>
      </div>
    </div>
  );
};

export default PillFilter;
